<template>
    <div>
        <top-navbar :padding="topPadding"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="pt-5" v-show="hasNotice">
                <app-status :remote-version="appVersion" @show="appStatus = true"></app-status>
                <offline-status @show="offlineStatus = true"></offline-status>
                <instructor-warnings @show="instructorWarnings = true"></instructor-warnings>
                <last-simulation @show="lastSimulation = true"></last-simulation>
            </div>

            <div class="row" v-if="$permissions.hasRight('dashboard.learners.read') && $permissions.hasRight('dashboard.cohorts.read')">
                <div class="col-md-6">
                    <learners></learners>
                </div>
                <div class="col-md-6">
                    <cohorts></cohorts>
                </div>
            </div>
            
            <div class="row" v-if="$permissions.hasRight('dashboard.learners.read') && !$permissions.hasRight('dashboard.cohorts.read')">
                <div class="col-md-12">
                    <learners></learners>
                </div>
            </div>
            
            <div class="row" v-if="!$permissions.hasRight('dashboard.learners.read') && $permissions.hasRight('dashboard.cohorts.read')">
                <div class="col-md-12">
                    <cohorts></cohorts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LastSimulation from './home/LastSimulation';
    import InstructorWarnings from './home/InstructorWarnings';
    import Cohorts from './home/Cohorts';
    import Learners from './home/Learners';
    import OfflineStatus from './offline/HomeStatus';
    import AppStatus from './offline/AppStatus';

    export default {

        components: {
            LastSimulation, InstructorWarnings, Cohorts, Learners, OfflineStatus, AppStatus
        },

        data() {
            return {
                appStatus: false,
                offlineStatus: false,
                instructorWarnings: false,
                lastSimulation: false,
            }
        },

        computed: {

            appVersion() {
                return this.$auth['config'].app_version
            },

            hasNotice() {
                return this.appStatus || this.offlineStatus || this.instructorWarnings || this.lastSimulation
            },

            topPadding() {
                return this.hasNotice ? 4 : 6
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/home')
            .then(resp => {
                next(vm => {
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },
    }
</script>
